<template>
  <div class="gridBox">
    <van-grid column-num="2">
      <van-grid-item>
        <div class="item">
          <div class="title">工作流名称</div>
          <van-field v-model="value" placeholder="请输入" />
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">所属财务部</div>
          <van-field v-model="value" placeholder="请输入" />
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">支付方式</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">币种</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">收款方</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">出差类型</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
    </van-grid>
    <div style="background: #fff; padding: 10px 20px">
      <div class="title">申请事由及说明</div>
      <van-field v-model="value" placeholder="请输入" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
    };
  },
  methods: {
    showPopup() {
      this.$emit("showPopup", "");
    },
  },
};
</script>

<style>
</style>